import React from 'react';
import { string } from 'prop-types';

import styles from './infoBox.module.css';

const EditorInfoBox = ({ title, text }) => (
  <div className={styles.infoBox}>
    <div className={`icon--info ${styles.infoIcon}`} />
    <div className={styles.infoContent}>
      <h2 className={styles.infoTitle}>{title}</h2>
      <div dangerouslySetInnerHTML={// eslint-disable-line react/no-danger
        { __html: text }
}
      />
    </div>
  </div>
);

EditorInfoBox.propTypes = {
  title: string.isRequired,
  text: string.isRequired
};

export default EditorInfoBox;
